<template>
  <Arb msg="Welcome to the future"/>
</template>

<script>
import Arb from './components/Arb.vue'

export default {
  name: 'App',
  components: {
    Arb
  }
}
</script>

<style>
body {
  background-color: #222;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
